import React, { useState, useEffect } from "react"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import Paper from "@mui/material/Paper"
import Pagination from "@mui/material/Pagination"
import { StyledMemberHistory } from "./Member.style"
import moment from "moment"

const MemberHistory = ({ member }) => {
  const [emailChangeHistory, setEmailChangeHistory] = useState([])
  const [displayEmailHistory, setDisplayEmailHistory] = useState([])
  const [page, setPage] = useState(1)

  const numPerPage = 8

  useEffect(() => {
    setEmailChangeHistory(member.emailUpdList || [])
  }, [member.emailUpdList])

  useEffect(() => {
    setDisplayEmailHistory(
      emailChangeHistory.slice((page - 1) * numPerPage, page * numPerPage)
    )
  }, [page, emailChangeHistory, numPerPage])

  const totalPages = Math.ceil(emailChangeHistory.length / numPerPage)

  return (
    <StyledMemberHistory>
      <div className="history-shell">
        <TableContainer component={Paper}>
          <div className="table-heading">Email Update History</div>
          <Table sx={{ minWidth: 650 }} aria-label="member history table">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Operator</TableCell>
                <TableCell>Email From</TableCell>
                <TableCell>To</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {displayEmailHistory.map((record) => {
                return (
                  <TableRow
                    key={`role-item-${record.id}`}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {moment(record.createdAtStamp).format("LLL")}
                    </TableCell>
                    <TableCell>{record.adminNickName}</TableCell>
                    <TableCell>{record.emailBefore}</TableCell>
                    <TableCell>{record.emailAfter}</TableCell>
                  </TableRow>
                )
              })}
              {displayEmailHistory.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4} className="history-empty">
                    No email update history available.
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell colSpan={1}>
                  <span className="total-count">
                    Total records: <strong>{emailChangeHistory.length}</strong>
                  </span>
                </TableCell>
                <TableCell colSpan={3}>
                  {totalPages > 1 && (
                    <div className="pagination-section">
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(event, value) => {
                          setPage(value)
                        }}
                      />
                    </div>
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </StyledMemberHistory>
  )
}

export default MemberHistory
